import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-bigquery-details',
  templateUrl: './help-bigquery-details.component.html',
  styleUrls: ['./help-bigquery-details.component.scss']
})
export class HelpBigqueryDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
